import { KbSearchBase } from "./kb-search-base";
import { html } from "lit-html";
import { storeInstance } from "store/index.js";
import { Router } from "@vaadin/router/dist/vaadin-router.js";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import * as kblib from "lib/kblib.js";
import getProductTreeId from "../utils/getProductTreeId";
import KbParser from "../utils/KbParser.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import "bds-tree";
import "./bds-property-filter";
import "./kb-view-more";

class KbTextSearch2 extends KbSearchBase {
  static get properties() {
    return {
      searchResults: { type: Array },
      searchTerm: { type: String },
      isFilterNodeSelected: { type: Boolean },
      helpsetId: { type: String },
      showList: { type: Object },
    };
  }

  constructor() {
    super();
    this.hasPaging = true;
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(
      "vaadin-router-location-changed",
      this.resetWithinHelpsetSearch.bind(this)
    );
  }

  disconnectedCallback() {
    window.removeEventListener(
      "vaadin-router-location-changed",
      this.resetWithinHelpsetSearch
    );
    super.disconnectedCallback();
  }

  getDataFromStore() {
    super.getDataFromStore();
    this.searchResults = this.state.search_results;
    this.searchTerm = this.state.search_term.searchterm;
    this.helpsetId = this.state.filter_helpset_id;
    this.controlDefs = this.state.panel_control_defs;
    this.productTreeId = getProductTreeId(this.controlDefs);
  }

  pageName = "kbsearch";

  getResults() {
    storeInstance.dispatch("getPanelSearchResults");
  }

  getAdjacentResults() {
    storeInstance.dispatch("getAdjacentPanelSearchResults");
  }

  /*--- URL Getters ---*/
  getSearchTerm() {
    let queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("searchTerm")) {
      return queryParams.get("searchTerm");
    } else {
      return "";
    }
  }

  getHelpsetId() {
    let queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("helpsetId")) {
      return queryParams.get("helpsetId");
    } else {
      return "";
    }
  }
  /*--- URL overrides ---*/

  parseQueryString() {
    storeInstance.dispatch("setState", {
      property: "search_term",
      value: {
        searchterm: this.getSearchTerm() || "",
      },
    });
    storeInstance.dispatch("setState", {
      property: "filter_helpset_id",
      value: this.getHelpsetId(),
    });
    super.parseQueryString();
    this.checkFilterNodeSelected();
  }

  generateQueryString(controlValues) {
    let queryString = super.generateQueryString(controlValues);
    let searchParams = new URLSearchParams(queryString);
    if (this.searchTerm) {
      searchParams.set("searchTerm", this.searchTerm);
    }
    if (this.helpsetId) {
      searchParams.set("helpsetId", this.helpsetId);
    }
    return searchParams.toString();
  }

  /*--- Helpset Filter ---*/
  checkFilterNodeSelected() {
    if (
      this.propertyFilterState[this.productTreeId] &&
      this.propertyFilterState[this.productTreeId] === this.helpsetId
    ) {
      this.isFilterNodeSelected = true;
    } else {
      this.isFilterNodeSelected = false;
    }
  }

  async updateTreeControlData() {
    let treeData = await kblib.getControlDefData(this.productTreeId);
    let controlData = this.state.control_def_data_array;
    let index = controlData.findIndex(
      (data) => data.controlDefId === this.productTreeId
    );
    controlData[index] = treeData;
    storeInstance.commit("setControlDefData", controlData);
  }

  activateWithinHelpsetSearch() {
    let helpsetId = this.getHelpsetId();
    storeInstance.dispatch("setState", {
      property: "filter_helpset_id",
      value: helpsetId,
    });
  }

  async resetWithinHelpsetSearch() {
    if (this.helpsetId && !window.location.href.includes("kbsearch")) {
      storeInstance.dispatch("setState", {
        property: "filter_helpset_id",
        value: "",
      });
      await this.updateTreeControlData();
    }
  }

  handlePropertyFilterClick(e) {
    super.handlePropertyFilterClick(e);
    this.checkFilterNodeSelected();
  }

  /**Legacy code begins:*/

  _pageHitsArray(item) {
    var retval = [];
    if (item.pageHits) {
      let responseDoc = new DOMParser().parseFromString(
        item.pageHits,
        "application/xml"
      );
      var pageInfo = responseDoc.getElementsByTagName("pageInfo");
      if (pageInfo.length > 0) {
        for (var i = 0; i < pageInfo.length; i++) {
          var pageNumEl = pageInfo[i].getElementsByTagName("pageNum");
          var pageTextEl = pageInfo[i].getElementsByTagName("pageHitText");
          if (pageNumEl[0] && pageTextEl[0]) {
            retval.push({
              hitText: pageTextEl[0].innerHTML,
              pageNum: pageNumEl[0].innerHTML,
            });
          }
        }
      }
    }
    return retval;
  }

  _populatePageHitsArray(item) {
    this.pageArray = [];
    this.numPageArrayColumns = 1;
    if (item.pageHits) {
      let responseDoc = new DOMParser().parseFromString(
        item.pageHits,
        "application/xml"
      );
      var pageInfo = responseDoc.getElementsByTagName("pageInfo");
      //var pageNumCollection = responseDoc.getElementsByTagName("pageNum")
      if (pageInfo.length > 0) {
        for (var i = 0; i < pageInfo.length; i++) {
          var pageNumEl = pageInfo[i].getElementsByTagName("pageNum");
          var pageTextEl = pageInfo[i].getElementsByTagName("pageHitText");
          if (pageNumEl && pageTextEl) {
            this.pageArray.push({
              hitText: pageTextEl.innerHTML,
              pageNum: pageNumEl.innerHTML,
            });
          }
        }
      }
    }
    if (this.pageArray.length > 0) {
      this.numPageArrayColumns = Math.floor(this.pageArray.length / 5);
    } else {
      this.numPageArrayColumns = 1;
    }
    if (this.numPageArrayColumns == 0) {
      this.numPageArrayColumns = 1;
    }
    if (this.numPageArrayColumns > 1) {
      this.numPageArrayColumns = 1;
    }
  }

  _gotoItem(item, e) {
    let parser = new KbParser();
    parser.setHref(item.kbResId);
    let parsedLink = parser.parse();
    Router.go(parsedLink);
  }
  // if (this.id) {
  //   Router.go(
  //     "/kb/" +
  //       this.state.langCode +
  //       "/" +
  //       item.itemExtId +
  //       "/" +
  //       this.id +
  //       "/" +
  //       item.kbResId
  //   );
  // } else {
  //   if (item.itemType) {
  //     switch (item.itemType) {
  //       case "helpset":
  //         var mode = "";
  //         if (item.IPC) {
  //           mode = "ipc";
  //         } else {
  //           mode = "topic";
  //         }
  //         Router.go(
  //           "/kb/" +
  //             this.state.langCode +
  //             "/" +
  //             item.itemExtId +
  //             "/" +
  //             mode +
  //             "/" +
  //             item.kbResId
  //         );
  //         break;
  //       case "folderview":
  //         //https://localhost:8443/kb/en-US/FV2/folder/79/2379
  //         var strUrl =
  //           "/kb/" +
  //           this.state.langCode +
  //           "/" +
  //           item.itemExtId +
  //           "/folder/" +
  //           item.collId;
  //         if (item.kbResId) {
  //           strUrl =
  //             "/kb/" +
  //             this.state.langCode +
  //             "/" +
  //             item.itemExtId +
  //             "/folder/" +
  //             item.collId +
  //             "/" +
  //             item.kbResId.replace("Xdfv_", "");
  //         }
  //         Router.go(strUrl);
  //         break;
  //       case "download":
  //         mode = "download";
  //         Router.go(
  //           "/kb/" +
  //             this.state.langCode +
  //             "/" +
  //             item.itemExtId +
  //             "/" +
  //             mode +
  //             "/" +
  //             item.kbResId
  //         );
  //         break;
  //       case "filePub":
  //         var strUrl = "/kb/" + this.state.langCode + "/" + item.itemExtId;
  //         Router.go(strUrl);
  //         break;
  // }

  _isIpc(itemLang) {
    var retval = false;
    if (itemLang.hasOwnProperty("flags")) {
      if (itemLang.flags == 1) {
        retval = true;
      }
    }
    return retval;
  }

  _pageHitClick(item, that, e) {
    //Currently only folderview hits have page numbers
    e.stopPropagation();
    if (item.kbResId) {
      var pageNum = e.currentTarget.id;
      var strUrl =
        "/kb/" +
        that.state.langCode +
        "/" +
        item.itemExtId +
        "/folder/" +
        item.collId +
        "/" +
        item.kbResId.replace("Xdfv_", "") +
        "/" +
        pageNum;
      Router.go(strUrl);
    }

    if (item.itemType === "filePub") {
      let pageNum = e.currentTarget.id;
      let newUrl =
        "/kb/" + that.state.langCode + "/" + item.itemExtId + "/" + pageNum;
      Router.go(newUrl);
    }
  }

  /*--- Templates ---*/
  filterString() {
    return this.helpsetId && this.isFilterNodeSelected
      ? html` <span>${`within helpset`}</span>`
      : null;
  }

  headerTemplate() {
    return html`
      <style>
        .highlight {
          color: var(--kb-searchterm-color);
        }
      </style>
      <h2 class="results-caption">
        ${this.searchTerm
          ? this.string["_searchresultsfor"]
          : this.string["_allresults"]}
        <span class="highlight">${this.searchTerm}</span>
        ${this.filterString()}
      </h2>
    `;
  }

  hitsTemplate(hit, item) {
    return html`
      <li
        class="list-item"
        @click="${this._pageHitClick.bind(hit.pageNum, item, this)}"
        id="${hit.pageNum}"
      >
        <strong>page ${hit.pageNum}:</strong> ${unsafeHTML(hit.hitText)}
      </li>
    `;
  }

  resultsTemplate() {
    return html`
    <style>
      #searchResultsContainer {
        background: var(--kb-text-results-container-background);
        margin: var(--kb-text-results-container-margin);
        padding: var(--kb-text-results-container-padding);
      }

        .helpset-filter {
          display: block;
          width: fit-content;
          background: var(--kb-base-highlight);
          padding: 0.25rem 0.5rem;
          margin-bottom: 0;
          margin-top: 0.5rem;
          font-size: 15px;
        }

        .targetsearchword {
          background-color: var(--kb-target-color);
        }

        .result-item {
          cursor: pointer;
          margin-top: 1.5rem;
        }
        .result-item h3 {
          cursor: pointer;
          margin: 0;
          color: var(--kb-text-result-name-color);
          font-weight: var(--kb-text-result-name-fontweight);
        }
        .result-item h3:hover {
          text-decoration: underline;
        }
        .result-item h3:active {
          color: var(--kb-on-surface-link-color-active);
        }
        .result-item h3:visited {
          color: var(--kb-on-surface-link-color-visited);
        }
        .hide {
          display: none;
        }
        ul {
          margin-top: 0.25rem;
        }
        .list-item {
          color: var(--kb-primary-color-400);
        }
        .list-item:hover {
          text-decoration: underline;
        }
        .list-item:active {
          color: var(--kb-on-surface-link-color-active);
        }
        .list-item:visited {
          color: var(--kb-on-surface-link-color-visited);
        }
        .caption {
          font-size: 80%;
          font-style: italic;
          color: var(--kb-text-result-description-color);
        }
        .pagelist {
          column-gap: var(--block-padding);
          width: 50%;
          padding-left: 1.5rem;
          list-style: none;
        }
    </style>
      <div id="searchResultsContainer">
        <h2 class="${!this.itemFilter ? "hide" : ""}">
        ${this.string["_resultswithin"]} 
        <span class='highlight'>${this.itemFilterDisplayName}</span> 
        </h2>

        ${this.visibleResults.slice(0, this.state.max_results).map(
          (item) =>
            html`<div
              class="result-item"
              @click=${this._gotoItem.bind(this, item)}
            >
              ${this._populatePageHitsArray(item)}
              <h3 data-cy="result-name">
                ${item.pubTitle}
                ${item?.resultType === "topic"
                  ? html`- ${item.topicTitle}`
                  : null}
              </h3>

              ${item.hitText
                ? html`<div>${unsafeHTML(item.hitText)}</div>`
                : null}
              <div class="caption">${item.itemPath}</div>
              <ul
                class="pagelist"
                style="columns: ${this
                  .numPageArrayColumns};-webkit-columns: ${this
                  .numPageArrayColumns};-moz-columns: ${this
                  .numPageArrayColumns};"
              >
                <kb-view-more
                  .items=${this._pageHitsArray(item)}
                  .template=${(el) => this.hitsTemplate(el, item)}
                  closedNum="1"
                ></kb-view-more>
              </ul>
            </div>`
        )}
        </div>
        </div>
      </div>
    `;
  }
}

customElements.define("kb-textsearch2", KbTextSearch2);
